import { ListItemButton } from '@mui/material';
import { ListItemText } from './ListItemText';

interface UserMenuItemProps {
  id: string;
  name: string;
  onClick?: (() => Promise<void>) | (() => void);
}

function UserMenuItem(props: UserMenuItemProps) {
  return (
    <ListItemButton id={props.id} disableRipple onClick={props.onClick}>
      <ListItemText primary={props.name} />
    </ListItemButton>
  );
}

export type { UserMenuItemProps };
export { UserMenuItem };
